import React from 'react';

import { Box, Popover, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { FolderColour } from './folderColour';
import { FolderColourSwatches } from './FolderColourSwatches';

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null;
  currentColour?: string | null;
  onClose: () => void;
  onSelect: (colour: FolderColour | null) => void | Promise<void>;
}

export const FolderColourPicker: React.FC<Props> = ({
  open,
  anchorEl,
  currentColour = null,
  onClose,
  onSelect,
}) => {
  const theme = useTheme();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box padding={2} minWidth={260}>
        <Typography variant="subtitle2" style={{ marginBottom: 8, color: theme.palette.text.primary }}>
          Folder colour
        </Typography>
        <FolderColourSwatches currentColour={currentColour} onSelect={onSelect} />
      </Box>
    </Popover>
  );
};
